import './App.css';
import Footer from './Components/footer';
import AppRoutes from './routes';



function App() {
  return (
    <div className="app d-flex flex-column min-vh-100">
      <main className="flex-fill">
        <AppRoutes />
        </main>
      <Footer />
    </div>
  );
}

export default App;
